import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { getAdminApplyApi, putAdminApplyApi } from '../../service';
import { Alert, message, Button, Drawer, Modal, Spin } from 'antd';
import { BetaSchemaForm } from '@ant-design/pro-components';
import classNames from 'classnames';
import moment from 'moment';
import { useEffect, useRef, useState } from 'react';
import { useDrawer } from './hooks/useDrawer';
import { createUseStyles } from 'react-jss';
import { useClientAuthThing } from '@/shared/hooks';
// css
const useStyles = createUseStyles({
    stepsWrap: {
        marginLeft: '30px',
        position: 'relative',
    },
    leftLine: {
        position: 'absolute',
        top: '18px',
        transform: 'translateX(5px)',
        height: 'calc(100% - 70px)',
        width: '1px',
        backgroundColor: 'var( --lj-primary-color )',
        '&.grey': {
            backgroundColor: '#aaa',
        },
    },
    steps: {
        height: '60px',
        display: 'flex',
        justifyContent: 'space-between',
    },
    left: {
        minWidth: '12px',
        width: '12px',
        height: '12px',
        borderRadius: '50%',
        border: '2px solid var( --lj-primary-color )',
        transform: 'translateY(50%)',
        '&::before': {
            content: '1',
            color: '#fff',
        },
        '&.grey': {
            borderColor: '#aaa',
            '&::before': {
                color: '#aaa',
            },
        },
    },
    leftSecond: {
        '&::before': {
            content: '2',
        },
    },
    staff: {
        height: '45px',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
    },
    info: {
        height: '45px',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
    },
    center: {
        flex: 1,
        marginLeft: '10px',
        minWidth: '100px',
        '& .staff1': {
            fontWeight: 'bold',
            '&.grey': {
                color: '#aaa',
            },
        },
    },
    right: {
        textAlign: 'right',
        '& .rightInfo': {
            color: '#aaa',
            msg: {
                textAlign: 'left',
            },
        },
    },
    tipAlert: {
        '& .ant-alert-icon': {
            alignSelf: 'flex-start',
            marginTop: '5px',
        },
    },
});
const ReceiverDraw = ({ id, onLoaded, visible, onVisibleChange, }) => {
    const { spinning, setSpinning, dataInfo, setDataInfo, stateMap } = useDrawer();
    const [modalVisible, setModalVisible] = useState(false);
    const globalProps = useClientAuthThing();
    const formRef = useRef();
    // css
    const styles = useStyles();
    const getAdminApply = () => {
        setSpinning(true);
        getAdminApplyApi(id)
            .then((res) => {
            setSpinning(false);
            if (res.code === 200) {
                setDataInfo(res.data ?? {});
                onLoaded?.();
            }
        })
            .catch(() => setSpinning(false));
    };
    const logout = () => {
        // 回到登录页
        globalProps?.logout?.();
    };
    // 倒计时modal
    const countDownModal = () => {
        let countDown = 3;
        let interVal = null;
        // 生成modal
        const modal = Modal.warning({
            content: `您已接受企业管理员，请重新登录`,
            title: '请重新登录',
            okText: '知道了（3）',
            cancelButtonProps: {
                disabled: true,
            },
            closable: false,
            maskClosable: false,
            onOk: () => {
                if (interVal) {
                    clearInterval(interVal);
                }
                modal?.destroy();
                logout();
            },
        });
        // 倒计时3秒开始
        interVal = setInterval(() => {
            countDown -= 1;
            modal.update({
                okText: `知道了（${countDown}）`,
            });
            if (countDown <= 0) {
                if (interVal) {
                    clearInterval(interVal);
                }
                modal?.destroy();
                logout();
            }
        }, 1000);
    };
    const ok = () => {
        putAdminApplyApi({
            ...dataInfo,
            id: id,
            verifyStatus: 2,
        }).then((res) => {
            if (res.code === 200) {
                countDownModal();
            }
        });
    };
    const cancelModal = () => {
        formRef.current?.resetFields();
        setModalVisible(false);
    };
    const refuse = (values) => {
        putAdminApplyApi({
            ...dataInfo,
            id: id,
            verifyStatus: 1,
            description: values.description,
        }).then((res) => {
            if (res.code === 200) {
                message.success('已拒绝');
                cancelModal();
                getAdminApply();
            }
        });
    };
    useEffect(() => {
        if (visible) {
            getAdminApply();
        }
    }, [visible]);
    return (_jsxs(Drawer, { title: "\u66F4\u6362\u7BA1\u7406\u5458", width: 500, visible: visible, onClose: () => onVisibleChange(false), footer: dataInfo.verifyStatus === 0 ? (_jsxs("div", { style: { textAlign: 'right' }, children: [_jsx(Button, { onClick: () => setModalVisible(true), style: { marginRight: '10px' }, children: "\u62D2\u7EDD" }), _jsx(Button, { type: "primary", onClick: ok, children: "\u63A5\u53D7" })] })) : (false), children: [_jsxs(Spin, { spinning: spinning, children: [_jsx(Alert, { className: styles.tipAlert, type: stateMap(dataInfo.verifyStatus)?.alertType, message: _jsxs(_Fragment, { children: [_jsx("div", { style: { fontWeight: 'bolder' }, children: "\u6210\u4E3A\u4F01\u4E1A\u7BA1\u7406\u5458" }), _jsxs("div", { style: { color: '#444', marginTop: '6px' }, children: [dataInfo.verifyStatus === 0 && (_jsx("span", { children: "\u63A5\u53D7\u540E\uFF0C\u60A8\u7684\u7BA1\u7406\u5458\u8EAB\u4EFD\u5C06\u5728\u91CD\u65B0\u767B\u5F55\u540E\u6B63\u5F0F\u751F\u6548\u3002" })), dataInfo.verifyStatus === 1 && (_jsxs("span", { children: ["\u60A8\u5DF2\u62D2\u7EDD\u6210\u4E3A\u3010", dataInfo.companyName, "\u3011\u7684\u4F01\u4E1A\u7BA1\u7406\u5458\u3002"] })), dataInfo.verifyStatus === 2 && (_jsxs("span", { children: ["\u60A8\u5DF2\u662F\u3010", dataInfo.companyName, "\u3011\u7684\u4F01\u4E1A\u7BA1\u7406\u5458\u3002"] })), dataInfo.verifyStatus === 3 && (_jsx("span", { children: "\u672C\u6B21\u4F01\u4E1A\u7BA1\u7406\u5458\u66F4\u6362\u7533\u8BF7\u5DF2\u88AB\u64A4\u9500 " })), dataInfo.verifyStatus === 4 && (_jsx("span", { children: "7\u5929\u5185\u672A\u63A5\u53D7\uFF0C\u672C\u6B21\u4F01\u4E1A\u7BA1\u7406\u5458\u66F4\u6362\u7533\u8BF7\u5DF2\u8FC7\u671F" }))] })] }), showIcon: true }), _jsxs("p", { style: {
                            marginTop: '20px',
                            marginBottom: '30px',
                            fontWeight: 'bolder',
                        }, children: ["\u4F01\u4E1A\u7BA1\u7406\u5458\u3010", dataInfo.employeeName, "\u3011\u9080\u8BF7\u60A8\u6210\u4E3A\u3010", dataInfo.companyName, "\u3011\u7684\u7BA1\u7406\u5458\u3002\u672C\u6B21\u9080\u8BF77\u5929\u5185\u6709\u6548\uFF0C\u8BF7\u4E8E", _jsx("span", { style: { color: 'var( --lj-primary-color )' }, children: dataInfo.createdDatetime &&
                                    moment(dataInfo.createdDatetime).format('YYYY-MM-DD') }), ' ', "\u524D\u5904\u7406"] }), _jsxs("div", { className: styles.stepsWrap, children: [_jsx("div", { className: classNames(styles.leftLine, {
                                    grey: [0, 3].includes(dataInfo.verifyStatus),
                                }) }), _jsxs("div", { className: styles.steps, children: [_jsx("i", { className: styles.left }), _jsx("div", { className: styles.center, children: _jsxs("div", { className: "staff1", children: [_jsx("span", { children: dataInfo.employeeName }), dataInfo.verifyStatus === 3 && (_jsx("div", { className: "msg", style: { color: '#aaa', fontWeight: 500 }, children: "\u5DF2\u64A4\u9500" }))] }) }), _jsx("div", { className: styles.right, children: _jsxs("div", { className: classNames(styles.info, 'rightInfo'), children: [_jsx("span", { className: "time", children: dataInfo.createdDatetime &&
                                                        moment(dataInfo.createdDatetime).format('YYYY-MM-DD HH:mm:ss') }), _jsx("span", { className: "msg", children: "\u7533\u8BF7\u66F4\u6362\u7BA1\u7406\u5458" })] }) })] }), _jsxs("div", { className: styles.steps, style: { marginTop: '40px' }, children: [_jsx("i", { className: classNames(styles.left, styles.leftSecond, {
                                            grey: [0, 3].includes(dataInfo.verifyStatus),
                                        }) }), _jsx("div", { className: styles.center, children: _jsxs("div", { className: classNames(styles.staff, {
                                                grey: [0, 3].includes(dataInfo.verifyStatus),
                                            }), children: [_jsx("span", { children: dataInfo.changeEmployeeName }), dataInfo.verifyStatus !== 3 && (_jsx("div", { className: "msg", style: {
                                                        fontWeight: 500,
                                                        color: stateMap(dataInfo.verifyStatus)?.color,
                                                    }, children: stateMap(dataInfo.verifyStatus)?.text }))] }) }), _jsx("div", { className: styles.right, children: dataInfo.verifyStatus !== 0 && (_jsxs("div", { className: classNames(styles.info, 'rightInfo'), children: [_jsx("span", { className: "time", children: dataInfo.modiDatetime &&
                                                        moment(dataInfo.modiDatetime).format('YYYY-MM-DD HH:mm:ss') }), [1, 4].includes(dataInfo.verifyStatus) && (_jsx("span", { className: "msg", children: dataInfo.description }))] })) })] })] })] }), _jsx(BetaSchemaForm, { visible: modalVisible, title: "\u62D2\u7EDD", formRef: formRef, onFinish: async (values) => {
                    refuse(values);
                }, modalProps: {
                    onCancel: () => cancelModal(),
                }, submitter: {
                    render: (props) => (_jsxs("div", { children: [_jsx(Button, { onClick: cancelModal, children: "\u53D6 \u6D88" }, "cancel"), _jsx(Button, { type: "primary", onClick: () => props.form?.submit?.(), children: "\u786E\u5B9A" }, "send")] })),
                }, layoutType: "ModalForm", layout: "vertical", columns: [
                    {
                        title: '拒绝原因：',
                        dataIndex: 'description',
                        valueType: 'textarea',
                        formItemProps: {
                            rules: [
                                {
                                    required: true,
                                    message: `请输入拒绝原因`,
                                },
                            ],
                        },
                        colProps: {
                            span: 24,
                        },
                        fieldProps: {
                            maxLength: 100,
                            showCount: true,
                            rows: 6,
                        },
                    },
                ] })] }));
};
export default ReceiverDraw;
